import { collectionState } from './collection.state';
import { collectionActions } from './collection.action';
import { collectionMutations } from './collection.mutation';

export default {
  namespaced: true,
  state: collectionState,
  getters: {},
  actions: collectionActions,
  mutations: collectionMutations,
};
